import PillButton from './PillButton';
import { useCivicInteractions } from '../hooks/useCivicInteractions';

interface ListenNowProps {
  spotifyUrl?: string | null;
  appleMusicUrl?: string | null;
  youtubeUrl?: string | null;
  songId: string;
}

export default function ListenNow({ spotifyUrl, appleMusicUrl, youtubeUrl, songId }: ListenNowProps) {
  const interactions = useCivicInteractions();

  if (!spotifyUrl && !appleMusicUrl && !youtubeUrl) {
    return null;
  }

  const handleListenNowClick = (platform: string) => {
    console.log('=== [ListenNow] CLICK FIRED ===');
    console.log('[ListenNow] Platform:', platform);
    console.log('[ListenNow] Story ID:', songId);
    console.log('[ListenNow] Calling trackListenNowClick...');
    interactions.trackListenNowClick(songId);
  };

  const spotifyIcon = (
    <svg
      className="w-[17px] h-[17px]"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
    </svg>
  );

  const appleMusicIcon = (
    <div className="relative w-[17px] h-[17px] flex items-center justify-center rounded transition-all duration-200 apple-music-bg" style={{ backgroundColor: 'rgba(255, 255, 255, 0.85)' }}>
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
        width="12"
        height="12"
        xmlns="http://www.w3.org/2000/svg"
        style={{ color: '#000' }}
      >
        <ellipse cx="8" cy="17.5" rx="2.5" ry="2" fill="currentColor" />
        <ellipse cx="15" cy="16" rx="2.5" ry="2" fill="currentColor" />
        <rect x="14.2" y="5" width="1.5" height="11" fill="currentColor" />
        <path d="M 8.5 6 L 15.7 5 L 15.7 7 L 8.5 8 Z" fill="currentColor" />
        <rect x="7.7" y="8" width="1.5" height="9.5" fill="currentColor" />
      </svg>
    </div>
  );

  const youtubeIcon = (
    <svg
      className="w-[17px] h-[17px]"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="2" y="6" width="20" height="12" rx="2" />
      <polygon points="10,9 15,12 10,15" fill="currentColor" stroke="none" />
    </svg>
  );

  return (
    <div>
      <div className="text-[15px] font-semibold leading-[20px] mb-3" style={{ letterSpacing: '0.5px', color: '#40E0D0', opacity: 0.88 }}>
        Listen Now
      </div>
      <div className="flex flex-wrap gap-3 max-[380px]:flex-col max-[380px]:gap-2">
        {spotifyUrl && (
          <PillButton href={spotifyUrl} icon={spotifyIcon} ariaLabel="Open on Spotify" className="px-5" onClick={() => handleListenNowClick('Spotify')}>
            Spotify
          </PillButton>
        )}
        {appleMusicUrl && (
          <PillButton href={appleMusicUrl} icon={appleMusicIcon} ariaLabel="Open on Apple Music" className="px-5" onClick={() => handleListenNowClick('Apple Music')}>
            Apple Music
          </PillButton>
        )}
        {youtubeUrl && (
          <PillButton href={youtubeUrl} icon={youtubeIcon} ariaLabel="Open on YouTube" className="px-5" onClick={() => handleListenNowClick('YouTube')}>
            YouTube
          </PillButton>
        )}
      </div>
    </div>
  );
}
